<template>
  <div>
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" label="Spinning"/>
    </div>

    <div v-else-if="!media || media.length === 0" class="no-media">
      <p>No unpurchased media available</p>
    </div>

    <div v-else>
      <div class="row">
        <div v-for="(item, index) in media"
             :key="index"
             class="col-sm-6 col-lg-4 col-xl-3 unpurchased">
          <MediaItem :index="index"
                     :media="item"
                     :gallery="gallery"
                     :favorite-enabled="favoriteEnabled"
                     :digital-item-id="digitalItemId"
                     cart-enabled
                     @toggle-favorite="toggleFavourite"
                     @select="$emit('open-media', $event)"/>


        </div>
      </div>
      <Pagination :total-pages="totalPages"
                  :currentPage="currentPage"
                  :paginationSize="paginationSize"
                  :paginationType="paginationType"
                  :loadingMore="loadingMore"
                  @load-more="$emit('load-more')"
                  @change-page="$emit('change-page', $event)"/>
    </div>
  </div>
</template>

<script>
import MediaItem from "@/domain/galleryTree/components/MediaItem.vue";
import Pagination from "@/domain/galleryTree/components/Pagination.vue";

export default {
  name: 'VerticalUnpurchased',
  components: {Pagination, MediaItem},

  props: {
    gallery: {
      type: Object,
      required: true
    },
    media: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingMore: {
      type: Boolean,
      default: false
    },
    activeTab: {
      type: String,
      default: 'unpurchased'
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    },
    paginationSize: {
      type: Number,
      default: 20
    },
    paginationType: {
      type: String,
      default: 'pagination'
    },
    digitalItemId: {
      type: Number,
      default: null
    },
    favoriteEnabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    toggleFavourite(item) {
      if (item.favorite) {
        this.$emit('remove-from-favourites', item.id)
      } else {
        this.$emit('add-to-favourites', item.id)
      }
    }
  }
}
</script>